import { atom } from 'jotai';

import { updateV2SocketData } from '../v2-helper';
import { createTableAccumulatorBunja } from './table-accumulator';

export type Markets = Record<string, Market> | null;

export interface Market {
  midPrice: string;
  markPrice: string;
  priceChangePct24h: string;
  turnover24h: string;
  fundingRate: string;
  fundingTime: string;
  fundingTimeBlocking?: FundingTimeBlocking;
}

export type FundingTimeBlockingNone = { None: { interval: number } };
export type FundingTimeBlockingLikely = { Likely: { interval: number } };
export type FundingTimeBlockingScheduled = { Scheduled: { from: string; until: string } };
export type FundingTimeBlocking = FundingTimeBlockingNone | FundingTimeBlockingLikely | FundingTimeBlockingScheduled;

export const marketsAtom = atom<Markets>(null);

export const subscribeMarketsBunja = createTableAccumulatorBunja(
  'market/pswaps',
  (store) => (wsData) => store.set(marketsAtom, (prev) => updateV2SocketData(prev || {}, wsData)),
);
